import { Components } from './components.js';
import { Pages } from './pages.js';

const selectors = {
  pages: Pages,
  components: Components
};

export { Components, Pages, selectors };
//# sourceMappingURL=index.js.map
